import { render } from "./UpdateDocumentsForm.vue?vue&type=template&id=66971d6f&scoped=true&ts=true"
import script from "./UpdateDocumentsForm.vue?vue&type=script&lang=ts"
export * from "./UpdateDocumentsForm.vue?vue&type=script&lang=ts"

import "./UpdateDocumentsForm.vue?vue&type=style&index=0&id=66971d6f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66971d6f"]])

export default __exports__